import { Box, Flex, Image, Stack, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";

import { getApiBaseUrl } from "@/config/config";

export async function getServerSideProps(context) {
    const { code } = context.query;
    const url = `${getApiBaseUrl()}/employee/${code}`;
    try {
        const response = await fetch(url, {
            method: "GET",
        });
        const data = await response.json();

        if (data?.status == "sucess") {
            return {
                props: {
                    data: data,
                },
            };
        } else {
            return {
                props: {
                    data: "error",
                },
            };
        }
    } catch (error) {
        console.error("Error fetch: ", error);
        return {
            props: {
                data: "error",
            },
        };
    }
}

const GeneratePdfDigitalCard = ({ data }) => {
    const router = useRouter();
    const id = router.query.id;

    function encodeUriAll(value, domain) {
        let url = domain;
        let url_to_encode = value.split(domain)[1];
        url_to_encode = encodeURIComponent(url_to_encode);

        url_to_encode = url_to_encode
            .replace("%2F", "/")
            .replaceAll("(", "%28")
            .replaceAll(")", "%29");

        if (value?.includes("http")) {
            return `${url}${url_to_encode}`;
        } else {
            return `https://${url}${url_to_encode}`;
        }
    }

    return (
        <Box
            pr={5}
            width="816px"
            minH="1344px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            backgroundImage="url('https://media.grupoguia.mx/assets/digital-card/background-card-new.jpg')"
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="center"
            fontFamily="Open Sans"
            fontWeight="500"
            css={{
                "@media print": {
                    width: "816px",
                    height: "1344px",
                    margin: 0,
                    padding: 0,
                    overflow: "hidden",
                    transform: "scale(1)",
                    ["& backgroundPosition"]: "center center",
                    ["& backgroundSize"]: "cover",
                },
                "@page": {
                    ["& size"]: "816px 1344px",
                    margin: 0,
                },
            }}
        >
            <Box top={24} position="absolute" mx="auto" minW="816px" justifyItems="center">
                <Box
                    borderRadius="full"
                    w="450px"
                    h="450px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    backgroundImage={`url(${encodeUriAll(data?.data?.profile_image || "", data?.data?.profile_image?.includes("uploads/profile/") ? "guiarvis.com/uploads/profile/" : "guiarvis.com/img/vacantes/")})`}
                    // backgroundColor='#D9D9D9'
                    backgroundSize="cover"
                    backgroundPosition="center center"
                    mb={6}
                    boxShadow="lg"
                />
                <Stack alignItems="center" justifyContent="center" mt={8} mb={12}>
                    <Text
                        color="white"
                        fontWeight="bold"
                        fontSize={data?.data?.full_name?.length > 26 ? "40px" : "50px"}
                        textTransform="uppercase"
                        textAlign="center"
                        lineHeight={1}
                    >
                        {data?.data?.full_name}
                    </Text>
                    <Text
                        color="#FFCD00"
                        fontWeight="500"
                        fontSize="35px"
                        textTransform="uppercase"
                        textAlign="center"
                    >
                        {data?.data?.job_position}
                    </Text>
                </Stack>

                <Stack>
                    <Box bg="#0049B1" py={2} px={8} rounded="full" w="700" boxShadow="lg">
                        <Link href={`tel:${data?.data?.phone || data?.data?.cellphone}`}>
                            <Flex gap={8} justifyContent="space-between" alignItems="center">
                                <Image
                                    src="https://media.grupoguia.mx/assets/digital-card/phone.svg"
                                    w="60px"
                                />
                                <Text
                                    color="white"
                                    fontWeight="500"
                                    fontSize="45px"
                                    textAlign="center"
                                    pb={0}
                                >
                                    {data?.data?.phone || data?.data?.cellphone}
                                </Text>
                                <Stack />
                            </Flex>
                        </Link>
                    </Box>
                    <Box bg="#0049B1" py={4} px={8} rounded="full" w="700" mt={6} boxShadow="lg">
                        <Link href={`mailto:${data?.data?.email}`}>
                            <Flex gap={12} justifyContent="space-between" alignItems="center">
                                <Image
                                    src="https://media.grupoguia.mx/assets/digital-card/mail.svg"
                                    w="70px"
                                />
                                <Text
                                    color="white"
                                    fontWeight="500"
                                    fontSize="40px"
                                    textAlign="center"
                                    pb={0}
                                >
                                    {data?.data?.email}
                                </Text>
                                <Stack />
                            </Flex>
                        </Link>
                    </Box>
                </Stack>
                <Flex w="100%" justifyContent="end" mt={24}>
                    <Link href={`https://grupoguia.mx/Asesores/${id}`}>
                        <Box
                            bg="#FFCD00"
                            px={10}
                            py={2}
                            mr={5}
                            borderBottomRightRadius="full"
                            borderTopLeftRadius="full"
                            boxShadow="xl"
                        >
                            <Text
                                color="#002649"
                                fontWeight="500"
                                fontSize="35px"
                                textAlign="center"
                                pb={0}
                            >
                                Consulta mi estado
                            </Text>
                        </Box>
                    </Link>
                </Flex>
            </Box>
            {/* Footer */}
            <Flex
                position="absolute"
                bottom="50px"
                left="50px"
                flexDirection="column"
                gap={2}
                alignItems="center"
            >
                <Flex alignItems="center" marginRight="5px">
                    <Image
                        src="https://media.grupoguia.mx/assets/digital-card/qr-grupoguia.svg"
                        w="180px"
                    />
                </Flex>
                <Flex alignItems="center" marginRight="5px">
                    <Link href="https://www.grupoguia.mx">
                        <Text fontSize="19px" color="white" fontWeight="bold">
                            www.grupoguia.mx
                        </Text>
                    </Link>
                </Flex>
                <Flex alignItems="center" gap={5}>
                    <Box
                        position="relative"
                        as={Link}
                        href="https://www.facebook.com/GrupoGuia/"
                        width="20px"
                    >
                        <Image
                            src="https://media.grupoguia.mx/assets/digital-card/facebook-icon.svg"
                            style={{ objectFit: "fill" }}
                        />
                    </Box>
                    <Box
                        position="relative"
                        as={Link}
                        href="https://www.instagram.com/grupo.guia/"
                        width="35px"
                    >
                        <Image
                            src="https://media.grupoguia.mx/assets/digital-card/instagram-icon.svg"
                            style={{ objectFit: "fill" }}
                        />
                    </Box>
                </Flex>
            </Flex>
        </Box>
    );
};

export default GeneratePdfDigitalCard;
